/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Google_ReconnectInputs */

const en_settings_google_reconnect = /** @type {(inputs: Settings_Google_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnect`)
};

const he_settings_google_reconnect = /** @type {(inputs: Settings_Google_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיבור מחדש`)
};

/**
* | output |
* | --- |
* | "Reconnect" |
*
* @param {Settings_Google_ReconnectInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_google_reconnect = /** @type {((inputs?: Settings_Google_ReconnectInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_ReconnectInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_reconnect(inputs)
	return he_settings_google_reconnect(inputs)
});